interface ModalHeaderProps {
    title: string
    desc?: string
}

function ModalHeader({ title, desc }: ModalHeaderProps) {
    return (
        <header className='px-4 py-3 border-b border-b-primary'>
            <h2>{title}</h2>
            {desc ? <p className='mt-2'>{desc}</p> : ''}
        </header>
    )
}

export default ModalHeader
